import { render, staticRenderFns } from "./AllGamesGameTile.vue?vue&type=template&id=4dde5430&scoped=true"
import script from "./AllGamesGameTile.vue?vue&type=script&lang=js"
export * from "./AllGamesGameTile.vue?vue&type=script&lang=js"
import style0 from "./AllGamesGameTile.vue?vue&type=style&index=0&id=4dde5430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dde5430",
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QImg,QIcon,QBtn});
